module.exports = __webpack_public_path__ + "static/media/实践九号A星.57d44567.png";